import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'

import { 
  getReviewExportList,
  getFieldList
} from '../../actions/publish'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};

class ReviewExport extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    fieldList: [], // 领域数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      TotalSerialNumber: "",
      KeyWord: "",
      Batch: "",
      Field: undefined,
      SerialNumber: "",
      UserName: "",
      TechnicalTitle: "",
      WorkUnit: "",
      Remarks: "",
    },
    labelObj: { // 筛选项key - label对应关系
      TotalSerialNumber: '总序号',
      KeyWord: '关键词',
      Batch: '批次',
      Field: '领域',
      SerialNumber: '序号',
      UserName: '姓名',
      TechnicalTitle: '技术职称',
      WorkUnit: '工作单位',
      Remarks: '备注',
    },
    labelListObj: { 
      Field: 'fieldList',
    },
    selectKeys: ['Field'],
    sortObj: {},
    page: {
      PageNo: 1,
      PageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1310,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }

    this.initParams()
  }

  initParams = () => {
    getFieldList().then(res => {
      if (res.DataList) {
        let list = res.DataList.map(v => {
          return {
            ID: v.FieldName,
            Name: v.FieldName
          }
        })
        this.setState({
          fieldList: list
        })
      }
    })
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        TotalSerialNumber: "",
        Batch: "",
        Field: undefined,
        SerialNumber: "",
        UserName: "",
        TechnicalTitle: "",
        WorkUnit: "",
        Remarks: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'TrainingTime') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }


  initData = () => {
    let param =  Object.assign({}, this.state.form, this.state.page)
    getReviewExportList(param).then(res => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            v.key = v.ID
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }


  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '总序号',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 120,
      },
      {
        title: '批次',
        dataIndex: 'Batch',
        width: 140,
        key: 'Batch',
      },
      {
        title: '领域',
        dataIndex: 'Field',
        key: 'Field',
        width: 160,
      },
      {
        title: '序号',
        dataIndex: 'SerialNumber',
        width: 100,
        key: 'SerialNumber',
      },
      {
        title: '姓名',
        dataIndex: 'UserName',
        key: 'UserName',
        width: 120,
      },
      {
        title: '技术职称',
        dataIndex: 'TechnicalTitle',
        width: 150,
        key: 'TechnicalTitle',
      },
      {
        title: '工作单位',
        dataIndex: 'WorkUnit',
        width: 300,
        key: 'WorkUnit',
      },
      {
        title: '备注',
        dataIndex: 'Remarks',
        key: 'Remarks',
        width: 160,
      },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      page: {
        PageNo: 1,
        PageSize: 10
      },
      form: {},
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };


  handleReset = (clearFilters) => {
    clearFilters()
  }

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
    if (key === 'FilingTimeOrApprovalTime') {
      if (!value) {
        newForm.Time_KS = ''
        newForm.Time_JS = ''
      } else {
        let startTime = value[0].format('YYYY-MM-DD')
        let endTime = value[1].format('YYYY-MM-DD')
        newForm.Time_KS = startTime
        newForm.Time_JS = endTime
      }
    } else {
      if (value instanceof Array && value.length > 0) {
        newForm[key] = value.join('^')
      } else {
        newForm[key] = value
      }
    }
    this.setState({
      form: newForm,
      loading: true
    }, () => this.initData())
    confirm()
  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.PageNo && pageSize == this.state.page.PageSize) {
      return
    }
    this.setState({
      page: {
        PageNo: page,
        PageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">总序号</div>
              <Input  value={this.state.form.TotalSerialNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'TotalSerialNumber')} 
                placeholder="请输入总序号"/>
            </div>
            <div className="form-item">
              <div className="form-label">批次</div>
              <Input  value={this.state.form.Batch}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Batch')} 
                placeholder="请输入批次"/>
            </div>
            <div className="form-item">
              <div className="form-label">领域</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.Field}
                onChange={(e) => this.onChangeForm(e, 'Field')} 
              >
                {
                  this.state.fieldList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>

            <div className="form-item">
              <div className="form-label">序号</div>
              <Input  value={this.state.form.SerialNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'SerialNumber')} 
                placeholder="请输入序号"/>
            </div>
            <div className="form-item">
              <div className="form-label">姓名</div>
              <Input  value={this.state.form.UserName}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'UserName')} 
                placeholder="请输入姓名"/>
            </div>
            <div className="form-item">
              <div className="form-label">技术职称</div>
              <Input  value={this.state.form.TechnicalTitle}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'TechnicalTitle')} 
                placeholder="请输入技术职称"/>
            </div>
            <div className="form-item">
              <div className="form-label">工作单位</div>
              <Input  value={this.state.form.WorkUnit}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'WorkUnit')} 
                placeholder="请输入工作单位"/>
            </div>
            <div className="form-item">
              <div className="form-label">备注</div>
              <Input  value={this.state.form.Remarks}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Remarks')} 
                placeholder="请输入备注"/>
            </div>
            

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">评审专家</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(ReviewExport));
